module.exports = "<div class=\"progress\" *ngIf=\"isSpinnerVisible\">\n  <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\n</div>\n"